module.exports = __webpack_public_path__ + "fonts/STKBureauSans-Light.f53ed6a062d11f1bb791d47775e036d0.eot";